import LazyVideo from "../components/LazyVideo";

export default function ParksNyc() {
  return (
    <div className="bg-gradient-to-b from-slate-100 to-royalBlue pt-24 sm:pt-32">
      <div className="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8 lg:mb-8">
        <p className="mx-auto mt-2 max-w-lg text-center text-4xl font-semibold tracking-tight text-balance text-gray-950 sm:text-5xl ">
          Portfolio of Previous Projects
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 p-4 max-w-screen-xl mx-auto">
        {/* Horizontal Text Box - Move this BELOW the first horizontal image to appear on second row */}
        <div className="col-span-3 sm:col-span-2 lg:col-span-2 row-span-1 aspect-video bg-white rounded-2xl shadow-md p-6 flex items-center justify-center text-center lg:grid-cols-2">
          <div>
            <h1 className="text-royalBlue text-xl pt-2 font-semibold">
              🚗 ParkNYC Commercial: Smarter Parking, Smoother City Life
            </h1>
            <p className="text-s text-gray-800">
              {" "}
              G.C.M. Production partnered with D&S AGENCY CORP for NYC DOT to
              produce a fast-paced, user-focused web commercial for ParkNYC —
              the official parking app of New York City. The campaign highlights
              how drivers can seamlessly pay for parking, extend time remotely,
              and skip the meter with just a few taps.
            </p>
          </div>
        </div>
        {/* Horizontal Video */}
        <div className="aspect-video col-span-3 bg-black rounded-2xl overflow-hidden shadow-md">
          <LazyVideo
            autoPlay
            muted
            loop
            controls
            playsInline
            className="w-full h-full object-cover"
          >
            <source
              src="../Imgs/ParksNYC/GCM Productions_ParkNYC_no cc, but embeded.mov"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </LazyVideo>
        </div>
      </div>
    </div>
  );
}
